module.exports = __webpack_public_path__ + "static/media/TA273_1.db2433e8.png";